import styled from '@emotion/styled/macro'

export const TimeSlotShowTime = styled.p`
    bottom: 0;
    color: black;
    display: none;
    margin: 0;
    padding: 0;
    pointer-events: none;
    position: absolute;
    z-index: 2;
`

export const Timeslot = styled.div<{
    isAbsence: boolean
    isWorking: boolean,
    colorContrast:string
    zoomLevelValue: string
}>`
  background: ${({ isAbsence }) => (isAbsence ? '#ffea8c' : 'white')};
  background-image: ${({ isWorking, colorContrast }) => (!isWorking
    ? `repeating-linear-gradient( 180deg, ${colorContrast}, ${colorContrast} 4px, transparent 4px, transparent 0px )`
    : null)
};
   border-bottom: 1px solid #b3b3b3;
   height: ${({ zoomLevelValue }) => (`${zoomLevelValue}px` || '30px')};
   &:hover {
      background-color: lightgray;   
   }
`

export const ColumnGridWrapper = styled.div`
  border-right: 1px solid #b3b3b3;
  flex-grow: 1;
`

export const TimeSlotWrapper = styled.div`
  color: rgba(60, 64, 67, 0.3);
  position: relative;

  &:hover ${TimeSlotShowTime}{
    display: block;
  }
`
